import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function ArchitectureHero() {
  return <section className="relative w-full pt-20 pb-32 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-208">
      {/* Background Image */}
      <div className="absolute top-0 right-0 pointer-events-none" style={{
      width: '100%',
      height: '800px'
    }} data-id="element-209">
        <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[12%] w-[100%] h-auto opacity-90" data-id="element-210" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-211">
        <div className="flex flex-col space-y-8" data-id="element-212">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 mt-20 w-fit" data-id="element-213">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-214">
              THE INSTRUCTION LAYER
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-5xl font-['Syne']" data-id="element-215">
            AI is making{' '}
            <span className="bg-blue-600 text-white px-3" data-id="element-216">decisions</span>
            <br data-id="element-217" />
            you never approved.
          </h1>

          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-218">
            Without enforcement, your standards are suggestions. Compliance
            becomes optional, brand guidelines get ignored, and approval
            workflows get skipped when models prioritize speed over accuracy.{' '}
            <strong className="text-black font-semibold" data-id="element-219">
              With Synthia, models don't decide. You do.
            </strong>
          </p>

          <div className="pt-4" data-id="element-220">
            <Link to="/how-it-works" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0066FF]" data-id="element-221">
              HOW IT WORKS
              <ArrowRight className="w-5 h-5" data-id="element-222" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}